import React from 'react';
import style from '../../css/About/Abpr.module.css';
import image from '../../assets/images/exp_card1_en_desktop-new-colors.webp';
import video from '../../assets/images/video.mp4';
import mission from '../../assets/images/mission.png';
import vission from '../../assets/images/vission.png';
import history from '../../assets/images/history.png';
import { Link } from 'react-router-dom';
import Stats from '../Stats';
import TrustCompany from '../TrustCompany';

function Abpr() {
	return (
		<div>
			{/* one */}
			<div className={style.abprContainer}>
				<div className={style.textSection}>
					<div className={style.breadcrumb}>
						<Link className={style.btn} to={'/'}>
							[Home
						</Link>
						<span className={style.highlight}>/ About]</span>
					</div>
					<h1 className={style.heading}>Welcome to Exporest –</h1>
					<p className={style.description}>
						At <strong>Exporest</strong>, we manage every part of your corporate
						travel—flights, hotels, cabs, and more—so you can focus on your
						business. Our experienced team works closely with you to deliver
						seamless and reliable travel experiences, from anywhere to anywhere.
						Wherever your company needs to go, we ensure your journey is
						effortless and efficient. Trust us to handle the details and make
						every trip smooth and productive.
					</p>
				</div>
				<video
					src={video}
					className={style.mainImage}
					alt="Corporate travel team planning"
					controls={false}
					autoPlay
					loop
					muted
				/>
			</div>
			<TrustCompany />

			<p className={style.descriptionSep}>
				Your One-Stop Travel Partner At <strong>Exporest</strong>, we are
				committed to delivering exceptional service with a personal touch.
				Whether it’s a quick domestic trip or a detailed international
				itinerary, we handle every aspect of your travel with precision and
				care.
			</p>

			<Stats />

			{/* two */}
			<div className={style.abprContainer}>
				<img
					src={mission}
					alt="Corporate travel team planning"
					className={style.mainImage}
				/>

				<div className={style.textSection}>
					<h1 className={style.heading}>Our Mission</h1>
					<p className={style.description}>
						Our mission is to simplify the travel process for both corporate
						clients and individual travelers by offering:
						<br />✅ Best-in-class corporate rates
						<br />✅ Custom travel plans based on your company’s policy <br />
						✅ Priority support and 24/7 customer service <br />✅ Expert
						handling of group bookings
					</p>
				</div>
			</div>

			{/* three */}
			<div className={style.abprContainer}>
				<div className={style.textSection}>
					<h1 className={style.heading}>Our Vision</h1>
					<p className={style.description}>
						We are more than just a travel agency – we are a trusted travel
						partner focused on efficiency, savings, and satisfaction. With a
						highly experienced team and access to top global inventories,
						Exporest ensures every journey is seamless, cost-effective, and
						stress-free.
					</p>
				</div>

				<img
					src={vission}
					alt="Corporate travel team planning"
					className={style.mainImage}
				/>
			</div>

			{/* four */}
			<div className={style.abprContainer}>
				<img
					src={history}
					alt="Corporate travel team planning"
					className={style.mainImage}
				/>

				<div className={style.textSection}>
					<h1 className={style.heading}>Our History</h1>
					<p className={style.description}>
						At <strong>Exporest</strong>, we manage every part of your corporate
						travel—flights, hotels, cabs, and more—so you can focus on your
						business. Our experienced team works closely with you to deliver
						seamless and reliable travel experiences, from anywhere to anywhere.
						Wherever your company needs to go, we ensure your journey is
						effortless and efficient. Trust us to handle the details and make
						every trip smooth and productive.
					</p>
				</div>
			</div>
		</div>
	);
}

export default Abpr;
